import Modal from 'src/components/Modal'
import * as S from './ModalNotIncludedInvoices.styles'
import { useEffect, useState } from 'react'
import { Box } from '@mui/material'

interface Props {
  isShow: boolean
  isFresh: boolean
  groceryInvoices: number[]
  freshInvoices: number[]
  isExternalOrder: boolean
  onOk?: () => void
  onCancel?: () => void
  onContinue?: () => void
}

interface ReceivementInvoices {
  type: string
  invoices: number[]
}

export const ModalNotIncludedInvoices = ({
  isShow, isFresh, groceryInvoices, freshInvoices, isExternalOrder, onOk, onCancel, onContinue,
}: Props) => {
  const [receivementInvoices, setReceivementInvoices] = useState<ReceivementInvoices>({
    type: '',
    invoices: [],
  })

  const [nextReceivementInvoices, setNextReceivementInvoices] = useState<ReceivementInvoices>({
    type: '',
    invoices: [],
  })

  useEffect(() => {
    if (isFresh) {
      setReceivementInvoices({
        type: 'FRESH',
        invoices: freshInvoices,
      })
      setNextReceivementInvoices({
        type: 'MERCEARIA',
        invoices: groceryInvoices,
      })
    } else {
      setReceivementInvoices({
        type: 'MERCEARIA',
        invoices: groceryInvoices,
      })
      setNextReceivementInvoices({
        type: 'FRESH',
        invoices: freshInvoices,
      })
    }
  }, [freshInvoices, groceryInvoices, isFresh])

  return (
    <Modal
      title={isExternalOrder ? 'Notas fiscais ou cupons não incluídos' : 'Notas fiscais não incluídas'}
      closedButton={false}
      body={(
        <S.ModalBody>
          <>
            {receivementInvoices.invoices.length > 0 && (
              <Box data-testid='receivement-invoices-test-id'>
                <S.TextInfo>
                  {isExternalOrder ? `As seguintes notas fiscais ou cupons também estão sendo esperados para este recebimento (${receivementInvoices.type}):`
                    : `As seguintes notas fiscais também estão sendo esperadas para este recebimento (${receivementInvoices.type}):`}
                </S.TextInfo>
                <S.InvoiceList maxHeight={nextReceivementInvoices.invoices.length === 0 ? '400px' : '200px'}>
                  {receivementInvoices.invoices.map((invoice) => (
                    <S.InvoiceItem key={invoice}>{invoice}</S.InvoiceItem>
                  ))}
                </S.InvoiceList>
              </Box>
            )}
            {nextReceivementInvoices.invoices.length > 0 && (
            <Box sx={{ marginTop: '.5rem' }} data-testid='next-receivement-invoices-test-id'>
              <S.TextInfo>
                {`Notas esperadas para recebimento ${nextReceivementInvoices.type}`}:
              </S.TextInfo>
              <S.InvoiceList maxHeight={receivementInvoices.invoices.length === 0 ? '400px' : '200px'}>
                {nextReceivementInvoices.invoices.map((invoice) => (
                  <S.InvoiceItem key={invoice}>{invoice}</S.InvoiceItem>
                ))}
              </S.InvoiceList>
            </Box>
            )}
            <S.TextInfo style={{ marginTop: '1rem' }}>
              {isExternalOrder ? 'Verifique com o comprador se ele possui essas notas fiscais ou cupons!'
                : 'Verifique com o fornecedor se ele possui essas notas fiscais!'}
            </S.TextInfo>
          </>
          <S.ModalFooter>
            {isExternalOrder ? (
              <S.ButtonOK
                title='OK'
                testId='ok-button-test-id'
                bgColor='blue'
                hoverColor='darkBlueHover'
                letterColor='white'
                size='medium'
                onClick={onOk}
              />
            ) : (
              <>
                <S.ButtonCancel
                  title='Sim, ele possui'
                  testId='cancel-button-test-id'
                  bgColor='blue'
                  hoverColor='darkBlueHover'
                  letterColor='white'
                  size='medium'
                  onClick={onCancel}
                />
                <S.ButtonContinue
                  title='Não, quero prosseguir'
                  testId='continue-button-test-id'
                  bgColor='confirm'
                  hoverColor='confirmHover'
                  letterColor='white'
                  size='medium'
                  onClick={onContinue}
                />
              </>
            )}
          </S.ModalFooter>
        </S.ModalBody>
    )}
      show={isShow}
      size='lg'
      testId='modal-not-included-invoices-test-id'
    />
  )
}
